import React from 'react'
import err from '../DesignAssets/error.png';
const Error = () => {
  return (
    <div><img alt="404 error" style={{height:"100vh",width:"100vw"}}src={err}/></div>
  )
}

export default Error